module.exports = __webpack_public_path__ + "static/media/FMA.53764e94.logo";